import { makeChartComp } from '../../util/makeChartComp';
var SankeyChart = makeChartComp('Sankey');
export default SankeyChart;
